module.exports = __webpack_public_path__ + "assets/img/icons.48581fdd.png";